import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./component/header";
import LoginSignup from "./pages/LoginSignup";
import Footer from "./component/footer";
import FormPage1 from "./pages/formPage1";
import FormPage2 from "./pages/formPage2";
import FormPage3 from "./pages/formPage3";
import FormStart from "./pages/formStart";
import Payment from "./pages/payment";
import FormPreview from "./pages/formPreview";
import FeesSubmitted from "./pages/feesSubmitted";
import SecureRoute from "./protectedRoute/secureRoute";
import PageNotfound from "./pages/pageNotfound";
// import { OutOfService } from "./pages/outOfService";
// import { useEffect, useState } from "react";

function App() {
  // const [block, setBlock] = useState(false);

  // useEffect(() => {
  //   const currentTime = new Date();

  //   const august3 = new Date(currentTime.getFullYear(), 7, 3, 23, 59, 0, 0);
  //   // Set the start date and time for August 5, 2023 (00:00 AM)
  //   const august5 = new Date(2023, 7, 5, 0, 0, 0, 0);

  //   // Set the end date and time for August 14, 2023 (11:59 PM)
  //   const august14 = new Date(2023, 7, 14, 23, 59, 0, 0);

  //   // Compare the current date and time with August 3, 11:59 PM
  //   if (currentTime < august3) {
  //     setBlock(false);
  //   } else if (currentTime >= august5 && currentTime <= august14) {
  //     setBlock(false);
  //   } else {
  //     setBlock(true);
  //   }
  // }, []);

  //   document.addEventListener('contextmenu', (e) => e.preventDefault());

  // function ctrlShiftKey(e, keyCode) {
  //   return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
  // }

  // document.onkeydown = (e) => {
  //   // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
  //   if (
  //     e.keyCode === 123 ||
  //     ctrlShiftKey(e, 'I') ||
  //     ctrlShiftKey(e, 'J') ||
  //     ctrlShiftKey(e, 'C') ||
  //     (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
  //   )
  //     return false;
  // };

  return (
    <Router>
      <Header />
      <Routes>
        {/* {block ? (
          <Route path="/" element={<OutOfService />} />
        ) : (
          <Route path="/" element={<LoginSignup />} />
        )} */}

<Route path="/" element={<LoginSignup />} />
        <Route
          path="/FormStart"
          element={
            <SecureRoute>
              <FormStart />
            </SecureRoute>
          }
        />
        <Route
          path="/FormPage1"
          element={
            <SecureRoute>
              <FormPage1 />
            </SecureRoute>
          }
        />
        <Route
          path="/FormPage2"
          element={
            <SecureRoute>
              <FormPage2 />
            </SecureRoute>
          }
        />
        <Route
          path="/FormPage3"
          element={
            <SecureRoute>
              <FormPage3 />
            </SecureRoute>
          }
        />
        <Route
          path="/FormPreview"
          element={
            <SecureRoute>
              <FormPreview />
            </SecureRoute>
          }
        />
        <Route
          path="/FeesSubmitted"
          element={
            <SecureRoute>
              <FeesSubmitted />
            </SecureRoute>
          }
        />
        <Route
          path="/Payment"
          element={
            <SecureRoute>
              <Payment />
            </SecureRoute>
          }
        />
        <Route path="*" element={<PageNotfound />} />
      </Routes>
      <Footer />
    </Router>
  );
}
export default App;
